import React, {useState, useEffect, Fragment} from 'react'
import {useDispatch, useSelector} from "react-redux"

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'

// Material-UI Lab
// import ToggleButton from '@material-ui/lab/ToggleButton'

// Material-UI Icon

// Custom Component
import useLoading from "../Loading/useLoading"
import CoverTable from "./CoverTable"

// Custom Style
import drawingRegisterStyle from '../../styles/jss/components/drawingRegister/drawingRegisterStyle'

// Fetch Data


const useStyles = makeStyles(theme => drawingRegisterStyle(theme))

const Covers = props => {
	const {annotSaveChangeAction, setAnnotSaveChangeAction} = props
	const store = require('store')
	const classes = useStyles()


	useEffect(() => {

	}, [])


	return (
		// console.log("File List | Variable: fileList (FileManager.js)"),
		// console.log(fileList),

		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			<CoverTable 
				annotSaveChangeAction={annotSaveChangeAction}
				setAnnotSaveChangeAction={setAnnotSaveChangeAction}
			/>
		</Fragment>
	)
}


export default Covers